import * as React from 'react';
import autobind from 'autobind-decorator';

import { ClientSalutationEditorView } from './client-salutation-editor.view';
import { AutocompleteListDataService } from 'src/core/ui/autocomplete/autocomplete.data';

interface ClientSalutationEditorControllerProps {
	label?: string;
	mode: ControlMode;
	value: string | null;
	onChanged: (value: string | null) => void;
	required?: boolean;
	setBusy(isBusy: boolean);
	onGetErrorMessage?: () => Promise<ValidationError[]>;
}

export class ClientSalutationEditorController extends React.Component<ClientSalutationEditorControllerProps, any> {
	protected dataService: AutocompleteListDataService;

	constructor(props) {
		super(props);
		this.dataService = AutocompleteListDataService.make();
	}

	@autobind
	protected titleQuery(q?: string) {
		this.props.setBusy(true);
		return new Promise<QueryResult<AutocompleteSummary>>((resolve, reject) => {
			this.dataService.addFilter('concept', 'eq', 'salutation');
			this.dataService.addFilter('key', 'eq', 'salutation');
			this.dataService.addSorting('value', 'asc', true);
			this.dataService.searchKeywords = q;
			this.dataService.pageSize = 100;
			return this.dataService
				.load(query => query)
				.then((items) => {
					this.props.setBusy(false);
					resolve({ items: items, totalCount: this.dataService.totalPages });
				})
				.catch(err => {
					this.props.setBusy(false);
					reject(err);
				});
		});
	}

	render() {
		return (
			<ClientSalutationEditorView
				onGetErrorMessage={this.props.onGetErrorMessage}
				required={this.props.required}
				mode={this.props.mode}
				titleQuery={{ query: this.titleQuery, dataSet: this.dataService }}
				onChanged={this.props.onChanged}
				value={this.props.value}
				label={this.props.label}
			/>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/crm/clients/parts/client-salutation-editor.controller.tsx